module.exports = __webpack_public_path__ + "static/media/refresh.a407e49a.svg";